'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isString = require('lodash/isString');
var classValidator = require('@nestjs/class-validator');
var classTransformer = require('class-transformer');
require('reflect-metadata');
var isNumber = require('lodash/isNumber');
var isBoolean = require('lodash/isBoolean');
var isPlainObject = require('lodash/isPlainObject');
var isNull = require('lodash/isNull');
var isUndefined = require('lodash/isUndefined');
var ISO6391 = require('iso-639-1');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var isString__default = /*#__PURE__*/_interopDefaultLegacy(isString);
var isNumber__default = /*#__PURE__*/_interopDefaultLegacy(isNumber);
var isBoolean__default = /*#__PURE__*/_interopDefaultLegacy(isBoolean);
var isPlainObject__default = /*#__PURE__*/_interopDefaultLegacy(isPlainObject);
var isNull__default = /*#__PURE__*/_interopDefaultLegacy(isNull);
var isUndefined__default = /*#__PURE__*/_interopDefaultLegacy(isUndefined);
var ISO6391__default = /*#__PURE__*/_interopDefaultLegacy(ISO6391);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

/**
 * Validates that JSON Object is a valid JSON Object with only
 * top-level string / number / boolean / null values.
 */

function IsDVCCustomDataJSONObject(validationOptions) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return function (object, propertyName) {
    classValidator.registerDecorator({
      name: 'isLongerThan',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate: validate$1,
        defaultMessage: function () {
          return '$property must be a JSON Object with only string / number / boolean / null types';
        }
      }
    });
  };
} // eslint-disable-next-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

function validate$1(json) {
  if (!isPlainObject__default["default"](json)) return false;

  for (var key in json) {
    if (!isString__default["default"](key)) return false;
    var value = json[key];

    if (isUndefined__default["default"](value) || !(isString__default["default"](value) || isNumber__default["default"](value) || isBoolean__default["default"](value) || isNull__default["default"](value))) {
      return false;
    }
  }

  return true;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$9 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$8 = fails$9;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$7 = fails$9;

var functionBindNative = !fails$7(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$4 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$4.bind(call$4) : function () {
  return call$4.apply(call$4, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$3 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$3, call$3);

var functionUncurryThisRaw = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$3.apply(fn, arguments);
  };
};

var uncurryThisRaw$1 = functionUncurryThisRaw;

var toString$3 = uncurryThisRaw$1({}.toString);
var stringSlice = uncurryThisRaw$1(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice(toString$3(it), 8, -1);
};

var classofRaw$1 = classofRaw$2;
var uncurryThisRaw = functionUncurryThisRaw;

var functionUncurryThis = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw$1(fn) === 'Function') return uncurryThisRaw(fn);
};

var uncurryThis$7 = functionUncurryThis;
var fails$6 = fails$9;
var classof$2 = classofRaw$2;

var $Object$3 = Object;
var split = uncurryThis$7(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$3('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$2(it) == 'String' ? split(it, '') : $Object$3(it);
} : $Object$3;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$5 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$3 = function (it) {
  if (isNullOrUndefined$1(it)) throw $TypeError$5("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;

var toIndexedObject$3 = function (it) {
  return IndexedObject(requireObjectCoercible$2(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$b = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$a = isCallable$b;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$5 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$a(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$a(it);
};

var global$9 = global$a;
var isCallable$9 = isCallable$b;

var aFunction = function (argument) {
  return isCallable$9(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};

var uncurryThis$6 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$6({}.isPrototypeOf);

var getBuiltIn$2 = getBuiltIn$3;

var engineUserAgent = getBuiltIn$2('navigator', 'userAgent') || '';

var global$8 = global$a;
var userAgent = engineUserAgent;

var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$5 = fails$9;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$5(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$1 = getBuiltIn$3;
var isCallable$8 = isCallable$b;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1('Symbol');
  return isCallable$8($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
};

var $String$2 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$2(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$7 = isCallable$b;
var tryToString = tryToString$1;

var $TypeError$4 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$7(argument)) return argument;
  throw $TypeError$4(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var call$2 = functionCall;
var isCallable$6 = isCallable$b;
var isObject$4 = isObject$5;

var $TypeError$3 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$6(fn = input.toString) && !isObject$4(val = call$2(fn, input))) return val;
  if (isCallable$6(fn = input.valueOf) && !isObject$4(val = call$2(fn, input))) return val;
  if (pref !== 'string' && isCallable$6(fn = input.toString) && !isObject$4(val = call$2(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$7 = global$a;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$1(global$7, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$7[key] = value;
  } return value;
};

var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.26.0',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.26.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$1 = requireObjectCoercible$3;

var $Object$1 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$1 = function (argument) {
  return $Object$1(requireObjectCoercible$1(argument));
};

var uncurryThis$5 = functionUncurryThis;
var toObject = toObject$1;

var hasOwnProperty = uncurryThis$5({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var uncurryThis$4 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$2 = uncurryThis$4(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$2(++id + postfix, 36);
};

var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$5.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$3 = function (name) {
  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$1 = functionCall;
var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$2 = wellKnownSymbol$3;

var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$2('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$1(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$2("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$4 = global$a;
var isObject$2 = isObject$5;

var document$1 = global$4.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document$1) && isObject$2(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$6 = descriptors;
var fails$4 = fails$9;
var createElement = documentCreateElement;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$6 && !fails$4(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$5 = descriptors;
var call = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$5 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$4 = descriptors;
var fails$3 = fails$9;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$4 && fails$3(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$1 = isObject$5;

var $String$1 = String;
var $TypeError$1 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$2 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$1($String$1(argument) + ' is not an object');
};

var DESCRIPTORS$3 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var anObject$1 = anObject$2;
var toPropertyKey = toPropertyKey$2;

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$3 ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$2 = DESCRIPTORS$2 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$1 = descriptors;
var hasOwn$4 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$1 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$4(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$1 || (DESCRIPTORS$1 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$3 = functionUncurryThis;
var isCallable$5 = isCallable$b;
var store$1 = sharedStore;

var functionToString = uncurryThis$3(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$5(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$3 = global$a;
var isCallable$4 = isCallable$b;

var WeakMap$1 = global$3.WeakMap;

var weakMapBasicDetection = isCallable$4(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$2 = global$a;
var isObject = isObject$5;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
var hasOwn$3 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$2.TypeError;
var WeakMap = global$2.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$3(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$1(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$3(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$3(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$2 = fails$9;
var isCallable$3 = isCallable$b;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails$2(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$2(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$2(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$3(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

var isCallable$2 = isCallable$b;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$1 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$2(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$2 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var push = uncurryThis$2([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$1(hiddenKeys$1, key) && hasOwn$1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$1 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$1;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$3;
var uncurryThis$1 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject = anObject$2;

var concat = uncurryThis$1([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$1 = fails$9;
var isCallable$1 = isCallable$b;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$1(detection) ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$2;
var defineBuiltIn = defineBuiltIn$1;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var wellKnownSymbol$1 = wellKnownSymbol$3;

var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable = isCallable$b;
var classofRaw = classofRaw$2;
var wellKnownSymbol = wellKnownSymbol$3;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString$1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$3;
var toString = toString$1;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails = fails$9;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $ = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

/**
 * Validates that string is not filled with spaces
 */

function IsNotBlank(validationOptions) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return function (object, propertyName) {
    classValidator.registerDecorator({
      name: 'isNotBlank',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate: validate
      }
    });
  };
}
function validate(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

var IS_ISO6391 = 'isISO6391';
/**
 * Check if the string is a valid [ISO 639-1](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2)
 * officially assigned country code.
 */

function isISO6391(value) {
  return typeof value === 'string' && isISO6391Validator(value);
}
/**
 * Check if the string is a valid [ISO 3166-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) official code.
 */

function IsISO6391(validationOptions) {
  return classValidator.ValidateBy({
    name: IS_ISO6391,
    validator: {
      validate: function (value, args) {
        return isISO6391(value);
      },
      defaultMessage: classValidator.buildMessage(function (eachPrefix) {
        return eachPrefix + '$property must be a valid ISO6391 code';
      }, validationOptions)
    }
  }, validationOptions);
}
function isISO6391Validator(value) {
  return ISO6391__default["default"].validate(value.toLocaleLowerCase());
}

var SDKTypeValues = ['client', 'server', 'mobile', 'api'];

var boolTransform = function boolTransform(_a) {
  var value = _a.value;

  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  }

  return value;
};

var dateTransform = function dateTransform(_a) {
  var value = _a.value;
  if (!value) return undefined;
  var numberValue = Number(value);

  if (!isNaN(numberValue)) {
    // value is a time string
    return new Date(numberValue);
  } else {
    // value is a date-time string
    return new Date(value);
  }
};
/**
 * Base API User Schema used by the Bucketing API where the only required field is user_id.
 */


var DVCAPIUser =
/** @class */
function () {
  function DVCAPIUser() {
    /**
     * SDK type
     */
    this.sdkType = 'api';
  }

  __decorate([classValidator.IsBoolean(), classValidator.IsOptional(), classTransformer.Transform(boolTransform), __metadata("design:type", Boolean)], DVCAPIUser.prototype, "isAnonymous", void 0);

  __decorate([classValidator.IsString(), IsNotBlank(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCAPIUser.prototype, "user_id", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "email", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "name", void 0);

  __decorate([IsISO6391(), classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "language", void 0);

  __decorate([classValidator.IsISO31661Alpha2(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "country", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "appVersion", void 0);

  __decorate([classValidator.IsNumber(), classValidator.IsOptional(), classTransformer.Type(function () {
    return Number;
  }), __metadata("design:type", Number)], DVCAPIUser.prototype, "appBuild", void 0);

  __decorate([IsDVCCustomDataJSONObject(), classValidator.IsOptional(), classTransformer.Transform(function (_a) {
    var value = _a.value;
    return isString__default["default"](value) ? JSON.parse(value) : value;
  }), __metadata("design:type", Object)], DVCAPIUser.prototype, "customData", void 0);

  __decorate([IsDVCCustomDataJSONObject(), classValidator.IsOptional(), classTransformer.Transform(function (_a) {
    var value = _a.value;
    return isString__default["default"](value) ? JSON.parse(value) : value;
  }), __metadata("design:type", Object)], DVCAPIUser.prototype, "privateCustomData", void 0);

  __decorate([classValidator.IsDate(), classValidator.IsOptional(), classTransformer.Transform(dateTransform), __metadata("design:type", Date
  /**
   * Set by SDK automatically
   */
  )], DVCAPIUser.prototype, "createdDate", void 0);

  __decorate([classValidator.IsDate(), classValidator.IsOptional(), classTransformer.Transform(dateTransform), __metadata("design:type", Date
  /**
   * Set by SDK to 'web'
   */
  )], DVCAPIUser.prototype, "lastSeenDate", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "platform", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "platformVersion", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "deviceModel", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), classValidator.IsIn(['client', 'server', 'mobile', 'api']), classTransformer.Transform(function (_a) {
    var value = _a.value;
    return value;
  }), __metadata("design:type", String)], DVCAPIUser.prototype, "sdkType", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCAPIUser.prototype, "sdkVersion", void 0);

  return DVCAPIUser;
}();
var DVCBucketingUser =
/** @class */
function (_super) {
  __extends(DVCBucketingUser, _super);

  function DVCBucketingUser() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([classValidator.IsOptional(), classTransformer.Transform(function (_a) {
    var value = _a.value;
    return isString__default["default"](value) ? JSON.parse(value) : value;
  }), __metadata("design:type", Object)], DVCBucketingUser.prototype, "optIns", void 0);

  return DVCBucketingUser;
}(DVCAPIUser);
/**
 * Client API User Schema that extends the base DVCAPIUser schema to add fields
 * from the Client SDKs like: isAnonymous, isDebug.
 * Also changes certain fields to be required from the Client SDKs.
 */

var DVCClientAPIUser =
/** @class */
function () {
  function DVCClientAPIUser() {}

  __decorate([classValidator.IsBoolean(), classTransformer.Transform(boolTransform), __metadata("design:type", Boolean)], DVCClientAPIUser.prototype, "isAnonymous", void 0);

  __decorate([classValidator.IsString(), IsNotBlank(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "user_id", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "email", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "name", void 0);

  __decorate([IsISO6391(), classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "language", void 0);

  __decorate([classValidator.IsISO31661Alpha2(), classValidator.IsOptional(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "country", void 0);

  __decorate([classValidator.IsString(), classValidator.IsOptional(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "appVersion", void 0);

  __decorate([classValidator.IsNumber(), classValidator.IsOptional(), classTransformer.Type(function () {
    return Number;
  }), __metadata("design:type", Number)], DVCClientAPIUser.prototype, "appBuild", void 0);

  __decorate([IsDVCCustomDataJSONObject(), classValidator.IsOptional(), classTransformer.Transform(function (_a) {
    var value = _a.value;
    return isString__default["default"](value) ? JSON.parse(value) : value;
  }), __metadata("design:type", Object)], DVCClientAPIUser.prototype, "customData", void 0);

  __decorate([IsDVCCustomDataJSONObject(), classValidator.IsOptional(), classTransformer.Transform(function (_a) {
    var value = _a.value;
    return isString__default["default"](value) ? JSON.parse(value) : value;
  }), __metadata("design:type", Object)], DVCClientAPIUser.prototype, "privateCustomData", void 0);

  __decorate([classValidator.IsDate(), classTransformer.Transform(dateTransform), __metadata("design:type", Date
  /**
   * Set by SDK automatically
   */
  )], DVCClientAPIUser.prototype, "createdDate", void 0);

  __decorate([classValidator.IsDate(), classTransformer.Transform(dateTransform), __metadata("design:type", Date
  /**
   * Set by SDK to 'web'
   */
  )], DVCClientAPIUser.prototype, "lastSeenDate", void 0);

  __decorate([classValidator.IsString(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "platform", void 0);

  __decorate([classValidator.IsString(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "platformVersion", void 0);

  __decorate([classValidator.IsString(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "deviceModel", void 0);

  __decorate([classValidator.IsString(), classValidator.IsIn(['client', 'mobile']), __metadata("design:type", String)], DVCClientAPIUser.prototype, "sdkType", void 0);

  __decorate([classValidator.IsString(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCClientAPIUser.prototype, "sdkVersion", void 0);

  __decorate([classValidator.IsBoolean(), classValidator.IsOptional(), classTransformer.Transform(function (_a) {
    var value = _a.value;
    return isString__default["default"](value) ? value === 'true' : value;
  }), __metadata("design:type", Boolean)], DVCClientAPIUser.prototype, "isDebug", void 0);

  return DVCClientAPIUser;
}();
var DVCOptInUser =
/** @class */
function () {
  function DVCOptInUser() {}

  __decorate([classValidator.IsString(), IsNotBlank(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCOptInUser.prototype, "user_id", void 0);

  return DVCOptInUser;
}();

/**
 * Public API Event type used in CF Workers / SDKs to define the public interface to an event.
 * All DVCEvents will be be saved as type = 'customEvent' events, where customType = DVCEvent.type,
 * and clientDate = DVCEvent.date.
 */

var DVCEvent =
/** @class */
function () {
  function DVCEvent() {}

  __decorate([classValidator.IsNotEmpty(), classValidator.IsString(), __metadata("design:type", String)], DVCEvent.prototype, "type", void 0);

  __decorate([classValidator.IsOptional(), classValidator.IsString(), __metadata("design:type", String)], DVCEvent.prototype, "target", void 0);

  __decorate([classValidator.IsOptional(), classValidator.IsNumber(), __metadata("design:type", Number)], DVCEvent.prototype, "date", void 0);

  __decorate([classValidator.IsOptional(), classValidator.IsNumber(), __metadata("design:type", Number)], DVCEvent.prototype, "value", void 0);

  __decorate([classValidator.IsOptional(), classValidator.IsObject(), __metadata("design:type", Object)], DVCEvent.prototype, "metaData", void 0);

  return DVCEvent;
}();
var SDKEventRequestBody =
/** @class */
function () {
  function SDKEventRequestBody() {}

  __decorate([classValidator.IsNotEmpty(), classValidator.ValidateNested(), classTransformer.Type(function () {
    return DVCAPIUser;
  }), __metadata("design:type", DVCAPIUser)], SDKEventRequestBody.prototype, "user", void 0);

  __decorate([classValidator.IsNotEmpty(), classValidator.IsArray(), classValidator.ValidateNested({
    each: true
  }), classTransformer.Type(function () {
    return DVCEvent;
  }), __metadata("design:type", Array)], SDKEventRequestBody.prototype, "events", void 0);

  return SDKEventRequestBody;
}();

/**
 * Supported filter comparators
 */
exports.FilterComparator = void 0;

(function (FilterComparator) {
  FilterComparator["="] = "=";
  FilterComparator["!="] = "!=";
  FilterComparator[">"] = ">";
  FilterComparator[">="] = ">=";
  FilterComparator["<"] = "<";
  FilterComparator["<="] = "<=";
  FilterComparator["exist"] = "exist";
  FilterComparator["!exist"] = "!exist";
  FilterComparator["contain"] = "contain";
  FilterComparator["!contain"] = "!contain";
})(exports.FilterComparator || (exports.FilterComparator = {}));

exports.BooleanFilterComparator = void 0;

(function (BooleanFilterComparator) {
  BooleanFilterComparator["="] = "=";
  BooleanFilterComparator["exist"] = "exist";
  BooleanFilterComparator["!exist"] = "!exist";
})(exports.BooleanFilterComparator || (exports.BooleanFilterComparator = {}));

exports.StringFilterComparator = void 0;

(function (StringFilterComparator) {
  StringFilterComparator["="] = "=";
  StringFilterComparator["!="] = "!=";
  StringFilterComparator["exist"] = "exist";
  StringFilterComparator["!exist"] = "!exist";
  StringFilterComparator["contain"] = "contain";
  StringFilterComparator["!contain"] = "!contain";
})(exports.StringFilterComparator || (exports.StringFilterComparator = {}));

exports.NumberFilterComparator = void 0;

(function (NumberFilterComparator) {
  NumberFilterComparator["="] = "=";
  NumberFilterComparator["!="] = "!=";
  NumberFilterComparator[">"] = ">";
  NumberFilterComparator[">="] = ">=";
  NumberFilterComparator["<"] = "<";
  NumberFilterComparator["<="] = "<=";
  NumberFilterComparator["exist"] = "exist";
  NumberFilterComparator["!exist"] = "!exist";
})(exports.NumberFilterComparator || (exports.NumberFilterComparator = {}));

exports.SemverFilterComparator = void 0;

(function (SemverFilterComparator) {
  SemverFilterComparator["="] = "=";
  SemverFilterComparator["!="] = "!=";
  SemverFilterComparator[">"] = ">";
  SemverFilterComparator[">="] = ">=";
  SemverFilterComparator["<"] = "<";
  SemverFilterComparator["<="] = "<=";
  SemverFilterComparator["exist"] = "exist";
  SemverFilterComparator["!exist"] = "!exist";
})(exports.SemverFilterComparator || (exports.SemverFilterComparator = {}));
/**
 * Supported filter types, defines high-level audience type.
 */


exports.FilterType = void 0;

(function (FilterType) {
  FilterType["all"] = "all";
  FilterType["user"] = "user";
  FilterType["optIn"] = "optIn";
  FilterType["audienceMatch"] = "audienceMatch"; // TODO: Implement later
  // listAudience = 'listAudience'
})(exports.FilterType || (exports.FilterType = {}));
/**
 * Supported `subType` values for `type = 'user'` filters
 */


exports.UserSubType = void 0;

(function (UserSubType) {
  UserSubType["user_id"] = "user_id";
  UserSubType["email"] = "email";
  UserSubType["ip"] = "ip";
  UserSubType["country"] = "country";
  UserSubType["platform"] = "platform";
  UserSubType["platformVersion"] = "platformVersion";
  UserSubType["appVersion"] = "appVersion";
  UserSubType["deviceModel"] = "deviceModel";
  UserSubType["customData"] = "customData";
})(exports.UserSubType || (exports.UserSubType = {}));
/**
 * ** TODO: Implement later **
 * Supported `subType` values for `type = 'listAudience'` filters.
 */


exports.ListAudienceSubType = void 0;

(function (ListAudienceSubType) {
  ListAudienceSubType["mixpanel"] = "mixpanel";
  ListAudienceSubType["csv"] = "csv";
})(exports.ListAudienceSubType || (exports.ListAudienceSubType = {}));
/**
 * Supported data key types
 */


exports.DataKeyType = void 0;

(function (DataKeyType) {
  DataKeyType["string"] = "String";
  DataKeyType["boolean"] = "Boolean";
  DataKeyType["number"] = "Number";
  DataKeyType["semver"] = "Semver";
})(exports.DataKeyType || (exports.DataKeyType = {}));

exports.AudienceOperator = void 0;

(function (AudienceOperator) {
  AudienceOperator["and"] = "and";
  AudienceOperator["or"] = "or";
})(exports.AudienceOperator || (exports.AudienceOperator = {}));
/**
 * Audience filter used to describe a segmentation for a user audience.
 */


var AudienceFilterOrOperator =
/** @class */
function () {
  function AudienceFilterOrOperator() {}

  return AudienceFilterOrOperator;
}();
/**
 * ** Initially only `and` operator will be supported **
 * Special filter used to establish a boolean operator. Can be used for top-level OR, etc.
 */

var TopLevelOperator =
/** @class */
function () {
  function TopLevelOperator() {}

  return TopLevelOperator;
}();
/**
 * Audience model used for describing a user segmenting audience
 */

var Audience =
/** @class */
function () {
  function Audience() {}

  return Audience;
}();

var Environment =
/** @class */
function () {
  function Environment() {}

  return Environment;
}();

exports.TargetingRuleTypes = void 0;

(function (TargetingRuleTypes) {
  TargetingRuleTypes["override"] = "override";
})(exports.TargetingRuleTypes || (exports.TargetingRuleTypes = {}));

var RolloutStage =
/** @class */
function () {
  function RolloutStage() {}

  __decorate([classTransformer.Type(function () {
    return Date;
  }), __metadata("design:type", Date
  /**
   * Target percentage this step should reach by the above date.
   */
  )], RolloutStage.prototype, "date", void 0);

  return RolloutStage;
}();
/**
 * Defines rollout configuration for a Target.
 */

var Rollout =
/** @class */
function () {
  function Rollout() {}

  __decorate([classTransformer.Type(function () {
    return Date;
  }), __metadata("design:type", Date
  /**
   * Stages of rollout
   */
  )], Rollout.prototype, "startDate", void 0);

  __decorate([classTransformer.Type(function () {
    return RolloutStage;
  }), __metadata("design:type", Array)], Rollout.prototype, "stages", void 0);

  return Rollout;
}();

var TargetDistribution =
/** @class */
function () {
  function TargetDistribution() {}

  return TargetDistribution;
}();
/**
 * Defines an Audience Target including the Audience model, rollout, and variation distribution
 * _id needed as it will be used as the seed in the hashing function to determine a given users position
 * in the bucketing and rollout
 */

var Target =
/** @class */
function () {
  function Target() {}

  __decorate([classTransformer.Type(function () {
    return Rollout;
  }), __metadata("design:type", Rollout
  /**
   * Specifies variation distribution percentages for features
   */
  )], Target.prototype, "rollout", void 0);

  return Target;
}();

var FeaturePrerequisites =
/** @class */
function () {
  function FeaturePrerequisites() {}

  return FeaturePrerequisites;
}();

var FeatureWinningVariation =
/** @class */
function () {
  function FeatureWinningVariation() {}

  return FeatureWinningVariation;
}();
/**
 * Feature Configuration Model. Defines the Environment-level model for a given feature.
 */

var FeatureConfiguration =
/** @class */
function () {
  function FeatureConfiguration() {}

  __decorate([classTransformer.Type(function () {
    return Target;
  }), __metadata("design:type", Array)], FeatureConfiguration.prototype, "targets", void 0);

  return FeatureConfiguration;
}();

exports.FeatureSource = void 0;

(function (FeatureSource) {
  FeatureSource["api"] = "api";
  FeatureSource["dashboard"] = "dashboard";
})(exports.FeatureSource || (exports.FeatureSource = {}));

var Variation =
/** @class */
function () {
  function Variation() {}

  return Variation;
}();
exports.FeatureType = void 0;

(function (FeatureType) {
  FeatureType["release"] = "release";
  FeatureType["experiment"] = "experiment";
  FeatureType["permission"] = "permission";
  FeatureType["ops"] = "ops";
})(exports.FeatureType || (exports.FeatureType = {}));
/**
 * Feature Model. Defines the project-level "container" for a given feature
 */


var Feature =
/** @class */
function () {
  function Feature() {}

  __decorate([classTransformer.Type(function () {
    return FeatureConfiguration;
  }), __metadata("design:type", FeatureConfiguration)], Feature.prototype, "configuration", void 0);

  return Feature;
}();

var Project =
/** @class */
function () {
  function Project() {}

  return Project;
}();

exports.VariableSource = void 0;

(function (VariableSource) {
  VariableSource["api"] = "api";
  VariableSource["dashboard"] = "dashboard";
  VariableSource["clientSDK"] = "clientSDK";
  VariableSource["serverSDK"] = "serverSDK";
})(exports.VariableSource || (exports.VariableSource = {}));
/**
 * Variable model, defines the project-level variables used in SDKs to change functionality.
 */


var Variable =
/** @class */
function () {
  function Variable() {}

  return Variable;
}();
/**
 * Supported variable types
 */

exports.VariableType = void 0;

(function (VariableType) {
  VariableType["string"] = "String";
  VariableType["boolean"] = "Boolean";
  VariableType["number"] = "Number";
  VariableType["json"] = "JSON";
})(exports.VariableType || (exports.VariableType = {}));

var ListAudience =
/** @class */
function () {
  function ListAudience() {}

  return ListAudience;
}();

var ConfigBody =
/** @class */
function () {
  function ConfigBody() {}

  __decorate([classTransformer.Type(function () {
    return Feature;
  }), __metadata("design:type", Array)], ConfigBody.prototype, "features", void 0);

  return ConfigBody;
}();

/**
 * API Populated Event type used in CF Workers / SDKs with all populated event data from the config data
 * ready to be sent to the Events API.
 */

var DVCPopulatedRequestEventDto =
/** @class */
function () {
  function DVCPopulatedRequestEventDto() {}

  __decorate([classValidator.IsString(), __metadata("design:type", String)], DVCPopulatedRequestEventDto.prototype, "type", void 0);

  __decorate([classValidator.IsOptional(), classValidator.IsString(), __metadata("design:type", String)], DVCPopulatedRequestEventDto.prototype, "target", void 0);

  __decorate([classValidator.IsOptional(), classValidator.IsString(), __metadata("design:type", String)], DVCPopulatedRequestEventDto.prototype, "customType", void 0);

  __decorate([classValidator.IsString(), classValidator.IsNotEmpty(), __metadata("design:type", String)], DVCPopulatedRequestEventDto.prototype, "user_id", void 0);

  __decorate([classValidator.IsNumber(), __metadata("design:type", Number)], DVCPopulatedRequestEventDto.prototype, "date", void 0);

  __decorate([classValidator.IsNumber(), __metadata("design:type", Number)], DVCPopulatedRequestEventDto.prototype, "clientDate", void 0);

  __decorate([classValidator.IsOptional(), classValidator.IsNumber(), __metadata("design:type", Number)], DVCPopulatedRequestEventDto.prototype, "value", void 0);

  __decorate([classValidator.IsNotEmpty(), __metadata("design:type", Object)], DVCPopulatedRequestEventDto.prototype, "featureVars", void 0);

  __decorate([classValidator.IsOptional(), __metadata("design:type", Object)], DVCPopulatedRequestEventDto.prototype, "metaData", void 0);

  return DVCPopulatedRequestEventDto;
}();

// Type to retrieve the element type from an array
function getVariableTypeFromValue(value, key, logger, shouldThrow) {
  if (typeof value === 'boolean') {
    return exports.VariableType.boolean;
  } else if (typeof value === 'number') {
    return exports.VariableType.number;
  } else if (typeof value === 'string') {
    return exports.VariableType.string;
  } else if (typeof value === 'object') {
    return exports.VariableType.json;
  } else {
    if (shouldThrow) {
      throw new Error("The default value for variable ".concat(key, " is not of type Boolean, Number, String, or JSON"));
    } else {
      logger.warn("The default value for variable ".concat(key, " is not of type Boolean, Number, String, or JSON"));
      return null;
    }
  }
}

exports.Audience = Audience;
exports.AudienceFilterOrOperator = AudienceFilterOrOperator;
exports.ConfigBody = ConfigBody;
exports.DVCAPIUser = DVCAPIUser;
exports.DVCBucketingUser = DVCBucketingUser;
exports.DVCClientAPIUser = DVCClientAPIUser;
exports.DVCEvent = DVCEvent;
exports.DVCOptInUser = DVCOptInUser;
exports.DVCPopulatedRequestEventDto = DVCPopulatedRequestEventDto;
exports.Environment = Environment;
exports.Feature = Feature;
exports.FeatureConfiguration = FeatureConfiguration;
exports.FeaturePrerequisites = FeaturePrerequisites;
exports.FeatureWinningVariation = FeatureWinningVariation;
exports.IsDVCCustomDataJSONObject = IsDVCCustomDataJSONObject;
exports.ListAudience = ListAudience;
exports.Project = Project;
exports.PublicAudience = Audience;
exports.PublicEnvironment = Environment;
exports.PublicFeature = Feature;
exports.PublicFeatureConfiguration = FeatureConfiguration;
exports.PublicProject = Project;
exports.PublicRollout = Rollout;
exports.PublicRolloutStage = RolloutStage;
exports.PublicTarget = Target;
exports.PublicVariable = Variable;
exports.PublicVariation = Variation;
exports.Rollout = Rollout;
exports.RolloutStage = RolloutStage;
exports.SDKEventRequestBody = SDKEventRequestBody;
exports.SDKTypeValues = SDKTypeValues;
exports.Target = Target;
exports.TargetDistribution = TargetDistribution;
exports.TopLevelOperator = TopLevelOperator;
exports.Variable = Variable;
exports.Variation = Variation;
exports.getVariableTypeFromValue = getVariableTypeFromValue;
exports.validate = validate$1;
